// extracted by mini-css-extract-plugin
export default {"containerWrapper":"styles_containerWrapper__OQTmy","rightSide":"styles_rightSide__zRHAn","searchInput":"styles_searchInput__eaKBz","flexWrapper":"styles_flexWrapper__NGKp7"};